import { graphql } from 'react-relay';

export const simplePageFragment = graphql`
  fragment SimplePage_page on SimplePage {
    components( first: 1000 ) {
      edges {
        node {
          __typename
          ...ArchiveList_component
        }
      }
    }
    breadcrumbs {
      ...Breadcrumb_data
    }
    path
    id
  }
`;
